/* eslint-disable react/jsx-indent, react/jsx-closing-tag-location */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import WizardStepTemplateContent from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
});

const Content = ({
  classes,
}) => {
  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      <WizardStepTemplateContent />
    </div>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
